import { Link } from 'react-router-dom';
import {
    Card,
    CardBody,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
} from 'reactstrap';
import { formatedCurrency } from '../../../../application/shared/FormatedCurrencies';
import { ProjectList } from '../../../../domain/projects/projectList';
import '../../../shared/components/styles/style.css';

interface Props {
    data: ProjectList[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export const CardProject = ({
    data: projects,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) => {
    return (
        <div className='d-flex flex-wrap gap-5 t-n4 py-3'>
            {projects.map((project) => (
                <Card key={project.id} className='custom-width-card shadow-lg'>
                    <CardBody>
                        <div
                            className={`p-3 mt-n3 mx-n3 bg-warning-subtle rounded-top`}
                        >
                            <div className='d-flex align-items-center'>
                                <div className='flex-grow-1'>
                                    <h5 className='mb-0 fs-14'>
                                        <Link
                                            to={
                                                '/projects/projects-list/' +
                                                project.id
                                            }
                                            className='text-dark'
                                        >
                                            {project.name}
                                        </Link>
                                    </h5>
                                    <div className='text-muted'>
                                        <p>{project.commercialName}</p>
                                        <div
                                            style={{
                                                borderRadius: '10px',
                                                border: '1px solid #ccc',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <span
                                                style={{
                                                    display: 'block',
                                                    marginRight: '10px',
                                                    marginLeft: '10px',
                                                    padding: '1px',
                                                }}
                                            >
                                                {project.stateName}
                                            </span>
                                            <div
                                                style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    marginRight: '10px',
                                                    borderRadius: '50%',
                                                    backgroundColor: project.color,
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex-shrink-0'>
                                    <div className='d-flex gap-1 align-items-center my-n2'>
                                        <UncontrolledDropdown direction='start'>
                                            <DropdownToggle
                                                tag='button'
                                                className='btn btn-link text-muted p-1 mt-n2 py-0 text-decoration-none fs-15'
                                            >
                                                <i className='ri-more-2-fill'></i>
                                            </DropdownToggle>

                                            <DropdownMenu className='dropdown-menu-end'>
                                                <Link
                                                    className='w-100 h-100'
                                                    to={
                                                        '/projects/projects-list/' +
                                                        project.id
                                                    }
                                                >
                                                    <DropdownItem>
                                                        <i className='ri-eye-fill align-bottom me-2 text-muted'></i>{' '}
                                                        Ver más
                                                    </DropdownItem>
                                                </Link>
                                                <Link
                                                    to={
                                                        '/projects/update-project/' +
                                                        project.id
                                                    }
                                                >
                                                    <DropdownItem>
                                                        <i className='ri-pencil-fill align-bottom me-2 text-muted'></i>{' '}
                                                        Editar
                                                    </DropdownItem>
                                                </Link>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex mb-2'>
                            <div className='d-flex justify-content-between flex-grow-0'>
                                <div></div>
                                <p className='text-muted mb-1'>
                                    {project.productChannel}
                                </p>
                            </div>
                        </div>
                        <div className='py-'>
                            <Row className='gy-3'>
                                <Col xs={6}>
                                    <div>
                                        <p className='text-muted mb-1'>Total Cost</p>
                                        <h5 className='fs-13'>
                                            {formatedCurrency(
                                                Number(project.totalCost)
                                            )}
                                        </h5>
                                    </div>
                                </Col>
                            </Row>
                            <div className='py-3'>
                                <Row className='gy-3'>
                                    <Col xs={6}>
                                        <div>
                                            <p className='text-muted mb-1'>
                                                Consultor
                                            </p>
                                            <h5 className='fs-13 mb-1'>
                                                {project.consultant}
                                            </h5>
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div>
                                            <p className='text-muted mb-1'>
                                                Comercial
                                            </p>
                                            <h5 className='fs-13'>
                                                {project.commercialEmployee}
                                            </h5>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div>
                            <div className='d-flex mb-2'>
                                <div className='d-flex justify-content-between flex-grow-1'>
                                    <div>Avance</div>
                                    <p>{project.percentage}%</p>
                                </div>
                            </div>
                            <div className='progress progress-sm animated-progress'>
                                <div
                                    className='progress-bar bg-success'
                                    role='progressbar'
                                    aria-valuenow={Number(project.percentage)}
                                    aria-valuemin={0}
                                    style={{ width: `${project.percentage}%` }}
                                ></div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            ))}
        </div>
    );
};
